import React, { Suspense } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import { Layout, Grid } from "antd";
import navigationConfig from "configs/NavigationConfig";
import { TEMPLATE, MEDIA_QUERIES } from "constants/ThemeConstant";
import styled from "@emotion/styled";
import utils from "utils";

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AppContent = styled("div")`
  // padding: ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
  margin-top: ${TEMPLATE.HEADER_HEIGHT}px;
  min-height: calc(100vh - ${TEMPLATE.CONTENT_HEIGHT_OFFSET}px);
  position: relative;

  ${(props) =>
    props.isNavTop
      ? `
        max-width: ${TEMPLATE.CONTENT_MAX_WIDTH}px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;

        @media ${MEDIA_QUERIES.DESKTOP} { 
            margin-top: ${TEMPLATE.HEADER_HEIGHT + TEMPLATE.TOP_NAV_HEIGHT}px;
            min-height: calc(100vh - ${TEMPLATE.CONTENT_HEIGHT_OFFSET}px - ${
          TEMPLATE.TOP_NAV_HEIGHT
        }px);
        }
    `
      : ""}

  @media ${MEDIA_QUERIES.MOBILE} {
    // padding: ${TEMPLATE.LAYOUT_CONTENT_GUTTER_SM}px;
  }
`;

const backgroundStyle = {
  // backgroundImage: "url(/img/auth-bg.webp)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

export const HomeLayout = ({ navType, direction, children }) => {
  const location = useLocation();
  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");
  const isNavTop = navType === TEMPLATE.NAV_TYPE_TOP;

  const getLayoutDirectionGutter = () => {
    if (direction === TEMPLATE.DIR_LTR) {
      return { paddingLeft: 0 };
    }
    if (direction === TEMPLATE.DIR_RTL) {
      return { paddingRight: 0 };
    }
    return { paddingLeft: 0 };
  };

  return (
    <Layout style={{ background: currentTheme === "light" && "#16183f" }}>
      <HeaderNav isMobile={isMobile} />
      {isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout style={{ ...getLayoutDirectionGutter(), ...backgroundStyle }}>
        <AppContent
          isNavTop={isNavTop}
          style={{ background: currentTheme === "light" && "#16183f" }}
        >
          <Content className="h-100">{children}</Content>
        </AppContent>
      </Layout>
      {isMobile && <MobileNav routeInfo={currentRouteInfo} />}
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navType, locale } = theme;
  return { navType, locale };
};

export default connect(mapStateToProps)(React.memo(HomeLayout));
